// Vendor
import $ from 'jquery';
import Helper from '../helpers/util';
import PageTracker from './PageTracker';

class Resource {
	constructor(el) {
		this.$el = $(el);
		this.$downloads = this.$el.find('.card__action-icon');

		this.attachEvents();
	}

	attachEvents() {
		if (this.$downloads.length) {
			this.$downloads.each((i, button) => {
				button.addEventListener('click', (e) => {
					PageTracker($(button).attr('data-track'));
				});
			});
		}
	}

}

const _init = () => {
	// Elements
	let $el = $('.card-elp-resource--wide');

	if ($el.length) {
		$el.each((e, v) => {
			if (!$(v).data('init')) {
				new Resource($(v));
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function() {
	_init();
});
